import { computed, ref } from "vue";
import imageTransformer from "@/plugins/imageTransformer";

const useUserProfile = (store, router) => {
  const user = computed(() => store.getters["userProfile/getUser"]);

  let userToUpdate = computed(() => ({
    displayName: user.value.displayName,
    description: user.value.description,
    email: user.value.email,
    twitterUsername: user.value.twitterUsername,
    websiteUrl: user.value.websiteUrl,
    profileImageId: user.value.profileImageId,
  }));

  const walletAddress = computed(
    () => store.getters["contracts/getAddressCardano"]
  );

  const walletBalance = computed(() =>
    store.getters["contracts/getBalanceByCurrency"]("THEOS")
  );

  const defaultAvatar = require("@/Common/Icons/Avatar.png");

  const data = computed(() => store.getters["userProfile/getByKey"]("data"));

  const avatarImage = () => {
    return user.value.profileImage
      ? imageTransformer.transform(
          user.value.profileImage.filename,
          "user.avatar"
        )
      : defaultAvatar;
  };
  const shortenedWalletAddress = () =>
    `${walletAddress.value.slice(0, 6)}...${walletAddress.value.slice(-4)}`;

  const getUserProperty = (key) =>
    computed(() => store.getters["userProfile/getByKey"](key));

  const handleSubmit = async () => {
    const updatedUser = await store.dispatch(
      "registration/updateUser",
      userToUpdate.value
    );
    await store.dispatch("userProfile/commitByKey", {
      user: updatedUser.data.data,
    });
    router.push("/profile");
  };

  const commitToStore = (object) =>
    store.dispatch("userProfile/commitByKey", object);

  const avatarInput = ref(null);
  const avatarImageSrc = ref(null);
  const spinner = ref(false);
  const uploadProfileAvatar = () => avatarInput.value.click();
  const avatarUploaded = async () => {
    spinner.value = true;
    const formData = new FormData();
    formData.append(
      "file",
      avatarInput.value.files[0],
      avatarInput.value.files[0].name
    );
    userToUpdate.value.profileImageId = await store.dispatch(
      "registration/storeProfileImageFile",
      formData
    );
    spinner.value = false;
    const uploadedImageUrl = URL.createObjectURL(avatarInput.value.files[0]);
    avatarImageSrc.value.src = uploadedImageUrl;
  };

  return {
    walletAddress,
    shortenedWalletAddress,
    walletBalance,
    handleSubmit,
    avatarImage,
    user,
    data,
    getUserProperty,
    commitToStore,
    userToUpdate,
    spinner,
    uploadProfileAvatar,
    avatarUploaded,
    avatarInput,
    avatarImageSrc,
  };
};

export default useUserProfile;
